import { React, useEffect, useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import Head from 'next/head'
import router from 'next/router'

import Header from '../../components/header'
import Footer from '../../components/footer'
import MiniCart from '../../components/cart/minicart'
import Noresults from '../../components/noresults'
import HomePaginator from '../../components/blog/homepaginator'

function Category({ list, menu, config, category_list }) {

  const [stored_list, set_stored_list] = useState(list);

  const enter_search = (event) => {
    event.preventDefault()
    const data = new FormData(event.target);
    const form = Object.fromEntries(data.entries())
    router.push({
      pathname: '/blog/search',
      query: { search: form.search },
    }, undefined, { shallow: true });
  }


  // check if we have a 'page' set, and if we do, load the correct data
  useEffect(() => {
    const taxonomy_data_api_call = async () => {
     
      if (!router.isReady) return;
      const page = router.query.page ? router.query.page : '1'
      
      var endpoint = '/blog'
      var headers = {
        'Content-Type': 'application/json',
      }

      fetch(
        process.env.NEXT_PUBLIC_API_URL + endpoint + '?page=' + page,
        {
          headers: headers,
          method: 'GET'
        }
      )
        .then(response => {
          
          // reject not ok response
          if (!response.ok) {
            return Promise.reject(response)
          }
          return response.json() // or return response.text()
        })
        .catch(async response => {
         
          if (!response.ok && response.redirected) {
            set_error('You have logged in on another device, please login again to see pricing')
          }
          const error = await response.json().then(text => text)
          return Promise.reject(error)
        })
        .then(data => {
          set_stored_list(data.data)
        })
        .catch((error) => {
          console.warn(error);
        });
    }
    if (router.query.page) {
      taxonomy_data_api_call();
    }
  }, [router.query.page]);

      // if list changes, reload it into the store
      useEffect(() => {
        set_stored_list(list)
    }, [router, list])

  return (
    <>
      <Head>
        <title>Blog</title>
      </Head>
      <section className="content flex flex-grow flex-col">
        <Header menu={menu} config={config}></Header>
        <div className="">
          <div className="container mx-auto text-xs py-2 px-5 lg:px-0">
            <div className="space-x-2 flex items-center leading-none">
              <Link href="/">
                <a className="cursor-pointer">
                  <i className="fas fa-home"></i>
                </a>
              </Link>
              <span className="text-gray-500">/</span>
              <span className="text-gray-900">
                Blog
              </span>
            </div>
          </div>
        </div>
        <div className="py-8">
          <div className="container mx-auto lg:mb-4 px-5 lg:px-0">
            <h1 className="font-bold text-4xl text-gray-900 mb-4">Latest Updates</h1>
            <div className="lg:flex">
              {
                (stored_list.data.length > 0) ? (
                  <div className="lg:w-3/5 mb-4">
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-6">
                      {stored_list.data.map((post) => (
                        <Link key={post.id} href={"/blog/" + post.url} passHref>
                          <div className="bg-white shadow rounded-lg p-1 relative border-2 border-white hover:border-brand-secondary hover:cursor-pointer active:border-brand-primary focus:border-brand-tertiary focus:ring-2 focus:ring-brand-tertiary transition-all">
                            <div className="img-latest-blog">
                              {(post.media && post.media[0] && post.media[0].original_url) ? (
                                <>
                                  <Image
                                    src={post.media[0].original_url}
                                    alt={post.name}
                                    width="500"
                                    height="180"
                                    className="w-full object-cover rounded-tl rounded-tr"
                                    placeholder="blur"

                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                  />
                                </>
                              ) : (
                                <>
                                  <Image
                                    src={process.env.NEXT_PUBLIC_COMING_SOON_IMAGE}
                                    alt={post.name}
                                    width="500"
                                    height="180"
                                    className="w-full object-cover rounded-tl rounded-tr"
                                    placeholder="blur"

                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                  />
                                </>
                              )}
                            </div>
                            <div className="p-4 lg:p-8">
                              <div className="text-brand-primary text-xs font-semibold uppercase mb-2 leading-none ">{post.taxonomies[0] ? post.taxonomies[0].name:''}</div>

                              <h4 className="h4 mb-2">{post.name}</h4>

                              <div className="text-gray-500 text-xs font-medium">
                                {new Date(post.created_at).toLocaleDateString(
                                  'en-gb',
                                  {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                    <HomePaginator last_page={stored_list.last_page}></HomePaginator>
                  </div>
                ) : (
                  <Noresults></Noresults>
                )
              }
              <div className="lg:w-1/4 lg:ml-auto space-y-5">
                <div>
                  <form
                    className="hidden lg:flex items-center flex-grow search h-12"
                    onSubmit={(event) => enter_search(event)}
                  >
                    <input
                      type="text"
                      name="search"
                      placeholder="Search blog posts"

                      className="flex w-full h-full rounded-tl rounded-bl placeholder-gray-500 leading-none text-gray-800 p-4 border border-gray-300 hover:border-brand-secondary active:border-brand-tertiary transition-all focus:outline-none focus:border-brand-tertiary focus:ring-2 focus:ring-inset focus:ring-brand-tertiary"
                    />
                    <button type="submit" className="btn btn-primary btn-searchbar h-full">
                      <i className="icon icon-search w-4 h-4"></i>
                    </button>
                  </form>
                </div>
                <div>
                  {category_list ? (
                    <>
                      <h4 className="h4 mb-2">Post Categories</h4>
                      <ul className="space-y-2 pl-3">
                        {category_list.map((category) => (
                          <li key={category.id}>
                            <Link href={"/blog/category/" + category.url}>
                              <a className="text-link">
                                {category.name}
                              </a>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : ('')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer menu={menu} config={config}></Footer>
      </section>
      <MiniCart></MiniCart>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const taxres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies/blog/')
  const taxresponse = await taxres.json()
  const category_list = taxresponse.data

  const listres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/blog/')
  const listresponse = await listres.json()
  const list = listresponse.data

  return {
    props: {
      config: config,
      menu: menu,
      list: list,
      category_list: category_list,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}



export default Category